<template>
  <div>
   <archivedReportsList/>
  </div>
</template>

<script>
import archivedReportsList from '../../../components/tax/payments/archivedReports/archivedReports.vue';

export default {
  name: 'ArchivedReports',
  components: {
    archivedReportsList,
  },
};
</script>
